import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import esLocale from "date-fns/locale/es";
import DateFnsUtils from "@date-io/date-fns";
import { useForm } from "../../../hooks/useForm";
import {
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  InputAdornment,
  Paper,
  Radio,
  RadioGroup,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  IconButton
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import {
  LIQUIDACIONES_COMPROBANTES_ESTADOS,
} from "../../../utils/constants";
import { AutoCompleteEfectorFacturacion } from "../UI/AutoCompleteEfectorFacturacion";
import {
  cleanAfiliadoSeleccionado,
  cleanComprobantes,
  clearReducer,
  getComprobantesContadoresGestion,
  getComprobantesTomadosPorUsuario,
  modificarEstadoComprobantes,
  setEstadoComprobantes
} from "../../../actions/liquidaciones/liquidaciones";
import { ComprobanteLiqItem } from "./ComprobanteLiqItem";
import { LIQUIDACIONES_GESTION_PERMISOS } from "../../../utils/permisos";
import { validarSoloUnPermiso } from "../../../helpers/permisos";
import { Search, Send } from "@material-ui/icons";
import { startAlerta } from "../../../actions/ui/alertas";


const useStyles = makeStyles({
  root: {
    padding: 10,
    flexGrow: 1,
    marginTop: -20,
    // width: "100%",
  },
  input: {
    padding: 10,
  },
  center: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
  },
});

const stateInitial = {
  fechaDesde: moment().subtract(30, 'days'),
  fechaHasta: moment(),
  idComprobante: null
};

let arrayEstadosLiquidaciones = [];

export function GestionFacturasHome(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {
    estadoComprobantes,
    comprobantes: items,
    efectorSeleccionado,
    contadores,
  } = useSelector((state) => state.liquidaciones);

  const { permisos: permisosUser } = useSelector(
    (state) => state.auth
  );

  const [
    formValues,
    ,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    ,
  ] = useForm(stateInitial);
  const { fechaDesde, fechaHasta, idComprobante } = formValues;
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [redirect, setRedirect] = useState(false);
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const [selected, setSelected] = useState([]);


  useEffect(() => {
    if (!props.location.state?.fromHomeScreen) {
      dispatch(clearReducer());
      dispatch(cleanComprobantes());
      dispatch(cleanAfiliadoSeleccionado());
      dispatch(getComprobantesTomadosPorUsuario());
    }
  }, [dispatch]);

  useEffect(() => {
    if (efectorSeleccionado?.idEfectorFacturacion || idComprobante) {
      // const minDate = moment(fechaDesde);
      // const maxDate = moment(fechaHasta);

      // if (maxDate.diff(minDate, 'days') > 30) {
      //   dispatch(startAlerta("El rango de fechas no puede superar los 30 dias.", "error"))
      // } else {

      dispatch(
        getComprobantesContadoresGestion(
          efectorSeleccionado?.idEfectorFacturacion,
          fechaDesde,
          fechaHasta,
          estadoComprobantes,
          idComprobante
        )
      );
    }
    // }

  }, [
    dispatch,
    efectorSeleccionado?.idEfectorFacturacion,
    fechaDesde,
    fechaHasta,
    estadoComprobantes,
  ]);

  useEffect(() => {
    arrayEstadosLiquidaciones = Object.entries(LIQUIDACIONES_COMPROBANTES_ESTADOS);

    const tieneBandejaCargaLinea =
      validarSoloUnPermiso(permisosUser,
        LIQUIDACIONES_GESTION_PERMISOS.CARGAR_LINEA);

    const tieneBandejaComprobantesRetornados =
      validarSoloUnPermiso(permisosUser,
        LIQUIDACIONES_GESTION_PERMISOS.COMPROBANTES_RETORNADOS);

    const tieneAuditoriaComprobante =
      validarSoloUnPermiso(permisosUser,
        LIQUIDACIONES_GESTION_PERMISOS.AUDITORIA_COMPROBANTE);

    const tieneGeneracionSolicitudPago =
      validarSoloUnPermiso(permisosUser,
        LIQUIDACIONES_GESTION_PERMISOS.GENERACION_SOLICITUD_PAGO);

    const tieneEnvioTesoreria = false       //SE OCULTA LA BANDEJA
    // validarSoloUnPermiso(permisosUser,
    //   LIQUIDACIONES_GESTION_PERMISOS.ENVIO_TESORERIA);

    arrayEstadosLiquidaciones = arrayEstadosLiquidaciones.filter(
      (estadoComprobante) =>
        (tieneBandejaCargaLinea &&
          ((estadoComprobante[1] ===
            LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA) || (estadoComprobante[1] === LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA))) ||
        (tieneAuditoriaComprobante &&
          estadoComprobante[1] ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_LIQUIDACION) ||
        (tieneBandejaComprobantesRetornados &&
          estadoComprobante[1] ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.RETORNADA) ||
        (tieneGeneracionSolicitudPago &&
          estadoComprobante[1] ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_SOLICITUD_PAGO) ||
        (tieneEnvioTesoreria &&
          estadoComprobante[1] ===
          LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO_TESORERIA) ||
        (estadoComprobante[1] === LIQUIDACIONES_COMPROBANTES_ESTADOS.ANULADA ||
          estadoComprobante[1] === LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA ||
          estadoComprobante[1] === LIQUIDACIONES_COMPROBANTES_ESTADOS.PAGADA
        )
    );

    if (arrayEstadosLiquidaciones.filter(s => s[1] === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA).length > 0) {
      dispatch(setEstadoComprobantes(LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA?.toString()));
    }

    if (arrayEstadosLiquidaciones.filter(s => s[1] === LIQUIDACIONES_COMPROBANTES_ESTADOS.PROFORMAS_PENDIENTES_CARGA).length > 0) {
      dispatch(setEstadoComprobantes(LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_CARGA?.toString()));
    }

  }, [permisosUser]);


  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = items.map((n) => n);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, item) => {
    const selectedIndex = selected.indexOf(item);
    let newSelected = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, item);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }
    setSelected(newSelected);
  };

  const isSelected = (idComprobante) => selected.filter(s => s.idComprobante === idComprobante).length > 0;

  const enviarTesoreria = () => {
    dispatch(modificarEstadoComprobantes(
      selected.map(s => s.idComprobante),
      LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA,
      setSelected,
      parseInt(estadoComprobantes),
      efectorSeleccionado?.idEfectorFacturacion,
      fechaDesde,
      fechaHasta,
    )
    );
  }

  const componentRef = React.useRef();

  const buscadorIdComprobante = () => {
    if (/^\d{4,}$/.test(idComprobante)) {
      dispatch(
        getComprobantesContadoresGestion(
          efectorSeleccionado?.idEfectorFacturacion,
          fechaDesde,
          fechaHasta,
          estadoComprobantes,
          idComprobante
        )
      );
    } else {
      dispatch(startAlerta("Debe ingresar 4 o mas dígitos", "error"))
    }
  }

  return (
    <Grid container className={classes.root} justify="center" spacing={1}>
      <Grid item xs={12}>
        <Grid container direction="row" alignItems="center" spacing={1}>
          <Grid item xs={12} md={5} style={{ marginRight: 5 }}>
            <AutoCompleteEfectorFacturacion todos dontExecuteFetch />
          </Grid>
          {/* <Grid item xs={12} md={1}>
            <Button
              //style={{ float: "right" }}
              color="primary"
              variant="contained"
              //disabled={selected.length === 0}
              onClick={buscarPorEfector}
              endIcon={<SearchIcon />}
            >
              BUSCAR
            </Button>
          </Grid> */}
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Desde"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  maxDate={fechaHasta}
                  maxDateMessage={`La fecha no puede ser posterior a la fecha Hasta`}
                  value={moment(fechaDesde).isValid()
                    ? moment(fechaDesde)
                    : null}
                  onChange={(date) => {
                    setearValor("fechaDesde", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
                <KeyboardDatePicker
                  margin="normal"
                  label="Fecha Hasta"
                  format="dd/MM/yyyy"
                  required={true}
                  clearLabel="Limpiar"
                  cancelLabel="Cancelar"
                  minDate={fechaDesde}
                  minDateMessage={`La fecha no puede ser anterior a la fecha de Desde`}
                  value={moment(fechaHasta).isValid()
                    ? moment(fechaHasta)
                    : null}
                  onChange={(date) => {
                    setearValor("fechaHasta", date);
                  }}
                  KeyboardButtonProps={{
                    "aria-label": "change date",
                  }}
                />
              </MuiPickersUtilsProvider>
            </Paper>
          </Grid>
          <Grid item xs={12} md={2}>
            <Paper className={classes.input}>
              <TextField
                margin="normal"
                // type='number'
                label="Id Comprobante"
                name="idComprobante"
                value={idComprobante}
                autoComplete="off"
                onChange={(e) => {
                  if (e.target.value === '' || e.target.value > 0) setearValor("idComprobante", e.target.value)
                }}
                onKeyUp={(e) => { if (e.key === 'Enter') buscadorIdComprobante() }}
                inputProps={{
                  pattern: "[0-9]*",
                }}
                InputProps={{
                  endAdornment:
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="Buscar"
                        onClick={buscadorIdComprobante}
                      >
                        <Search />
                      </IconButton>
                    </InputAdornment>
                }}
              />
            </Paper>
          </Grid>
          {parseInt(estadoComprobantes) === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO_TESORERIA &&
            <Grid item xs={12} md={2} >
              <Button
                style={{ float: "right" }}
                color="primary"
                variant="contained"
                disabled={selected.length === 0}
                onClick={enviarTesoreria}
                endIcon={<Send />}
              >
                Enviar Tesoreria
              </Button>
            </Grid>
          }
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Paper style={{ padding: "0.25rem" }}>
          <RadioGroup
            row
            style={{ justifyContent: "space-around" }}
            value={estadoComprobantes}
            onChange={(e) => {
              dispatch(setEstadoComprobantes(e.target.value));
            }}
          >
            {Array.isArray(Object.entries(arrayEstadosLiquidaciones)) &&
              Object.entries(arrayEstadosLiquidaciones).map((itemEstadoComp) => {
                const contador = contadores.find(s => s.idEstado === itemEstadoComp[1][1]);
                const label =
                  itemEstadoComp[1][0].charAt(0) +
                  itemEstadoComp[1][0].replaceAll("_", " ").toLowerCase().slice(1) +
                  ((contador && contador !== undefined)
                    ?
                    `(${contador.total})`
                    :
                    `(...)`
                  );
                return (
                  <FormControlLabel
                    key={itemEstadoComp[1][1]?.toString()}
                    style={{ marginLeft: "0.5rem" }}
                    label={label}
                    value={itemEstadoComp[1][1]?.toString()}
                    control={<Radio />}
                  />
                );
              })}
          </RadioGroup>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <TableContainer component={Paper} style={{ overflowX: "auto" }}>
          <Table size={dense ? "small" : "medium"} ref={componentRef}>
            <TableHead>
              <TableRow>
                {parseInt(estadoComprobantes) === LIQUIDACIONES_COMPROBANTES_ESTADOS.PENDIENTE_ENVIO_TESORERIA &&
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={selected.length > 0 && selected.length < items.length}
                      checked={items.length > 0 && selected.length === items.length}
                      onChange={handleSelectAllClick}
                      inputProps={{ "aria-label": "seleccionar todos los afiliados" }}
                    />
                  </TableCell>
                }
                <TableCell></TableCell>
                <TableCell align="left">Estado</TableCell>
                <TableCell align="left">Id Comprobante</TableCell>
                <TableCell align="left">N° Factura</TableCell>
                <TableCell align="left">Cliente</TableCell>
                <TableCell align="left">Cuit</TableCell>
                <TableCell align="left">P</TableCell>
                <TableCell align="left">Total Comprobante</TableCell>
                <TableCell align="left">Tipo Factura</TableCell>
                <TableCell align="left">Fecha Recepción</TableCell>
                <TableCell align="left">Fecha Vencimiento</TableCell>
                <TableCell align="left">Tomada</TableCell>
                {parseInt(estadoComprobantes) === LIQUIDACIONES_COMPROBANTES_ESTADOS.ENVIADA_TESORERIA &&
                  <TableCell align="left">Solicitud Pago N°</TableCell>
                }
                <TableCell align="left"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.length > 0 && (
                items.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => {
                    const isItemSelected = isSelected(item.idComprobante);

                    return (
                      <ComprobanteLiqItem
                        item={item}
                        fechaDesde={fechaDesde}
                        fechaHasta={fechaHasta}
                        key={item.idComprobante}
                        handleClick={handleClick}
                        isItemSelected={isItemSelected}
                        estadoComprobantes={estadoComprobantes}
                        labelId={`enhanced-table-checkbox-${index}`}
                        idEfectorFacturacion={efectorSeleccionado?.idEfectorFacturacion}
                      />
                    );
                  }))}
              {items.length === 0 && (
                <TableRow style={{ height: 50 }}>
                  <TableCell
                    colSpan={13}
                    style={{ textAlign: "-webkit-center" }}
                  >
                    {" "}
                    Sin Registros
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Grid>
      {items.length > 0 && (
        <Grid item xs={12}>
          <TablePagination
            style={{ backgroundColor: "white" }}
            rowsPerPageOptions={[100, 200, 500]}
            component="div"
            count={items.length}
            rowsPerPage={rowsPerPage}
            labelRowsPerPage="Registros por página"
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={handleChangeRowsPerPage}
          />
          <FormControlLabel
            control={
              <Switch
                checked={dense}
                onChange={(e) => setDense(e.target.checked)}
              />
            }
            label="Tamaño compacto"
          />
        </Grid>
      )}
      {/* {redirect && (
        <Redirect
          to={{
            pathname: '/autorizaciones',
            state: {
              from: '/autorizaciones/gestion'
            },
          }}
        />
      )} */}
    </Grid>
  );
};